import { convertToResourceKeyFromPath } from './converter';

export const getResources = () => {
  const entryType = 'resource' as const;

  if (PerformanceObserver.supportedEntryTypes.includes(entryType) === false) {
    throw new Error('[atf] PerformanceResourceTiming API 지원 안 함');
  }

  const resources = window.performance.getEntriesByType(entryType);

  return resources.reduce<Record<string, PerformanceResourceTiming>>((prev, resource) => {
    const key = convertToResourceKeyFromPath(resource.name);

    if (prev[key]) {
      return prev;
    }

    return {
      ...prev,
      [key]: resource as PerformanceResourceTiming,
    };
  }, {});
};
